import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NoDataSize, NoDataType } from '@zaoblako/web/shared/components/no-data/constants/no-data-types.enum';
import { NO_DATA_SIZES_CONFIG } from '@zaoblako/web/shared/components/no-data/constants/no-data-sizes.constants';

@Component({
  standalone: true,
  selector: 'crm-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoDataComponent implements OnChanges{
  @Input() public type = NoDataType.FULL;
  @Input() public size = NoDataSize.L;

  public sizeRem = NO_DATA_SIZES_CONFIG[this.size];

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.size?.currentValue) this.sizeRem = NO_DATA_SIZES_CONFIG[this.size];
  }
}
